'use client';
import { useEffect } from 'react';
 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import StorySection from'./components/StorySection';
 import MissionVision from'./components/MissionVision';
 import FounderDesk from'./components/FounderDesk';
 import Timeline from'./components/Timeline';
 import StatsSection from'./components/StatsSection';

export default function AboutPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach((el) => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <>
      <Header />
      <main className="pt-32">
        {/* Page Header */}
        <section className="pb-20 bg-background">
          <div className="max-w-5xl mx-auto px-6 text-center reveal">
            <div className="flex items-center justify-center gap-4 mb-6">
              <div className="w-[2px] h-4 bg-amber-500" />
              <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
                About Us
              </span>
            </div>
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-8 text-white">
              Classic24 Digital<br />Solutions
            </h1>
            <p className="text-lg md:text-xl text-zinc-400 max-w-3xl mx-auto leading-relaxed">
              A decade of digital excellence in Ulhasnagar, innovation, and transformative results. We're not just a digital agency – we're your partners in success.
            </p>
          </div>
        </section>

        <StorySection />
        <MissionVision />
        <FounderDesk />
        <Timeline />
        <StatsSection />

        {/* CTA Section */}
        <section className="py-20 md:py-32 bg-zinc-950 border-y border-zinc-800">
          <div className="max-w-4xl mx-auto px-6 text-center reveal">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 text-white">
              Ready to Work Together?
            </h2>
            <p className="text-lg text-zinc-400 mb-8">
              Let's create something amazing for your business.
            </p>
            <a
              href="/contact"
              className="inline-flex px-8 py-4 bg-amber-500 text-white rounded-xl hover:bg-amber-600 transition-all shadow-lg hover:shadow-amber-500/50 font-semibold"
            >
              Get in Touch
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}